import { constantRouteMap } from '@/router'
import authPages from '@/router/authPages'
import { getMenus } from '@/api/user'
import { getSideMenus } from '@/utils/routerMenu'

const constantRoutes = getSideMenus(JSON.parse(JSON.stringify(constantRouteMap)))

/**
 * 根据远程路由表，接入页面对应的异步组件
 * @param routes
 */
function accessAsyncRoutes (routes) {
  routes.forEach((route) => {
    const page = authPages[route.component] || null
    route.component = page
    if (!page && (route.meta || {}).app) {
      route.component = authPages.Spa
    } else if (!page && !route.redirect) {
      route.redirect = '/404'
    }
    if (route.children && route.children.length) {
      route.children = accessAsyncRoutes(route.children)
    }
  })
  return routes
}

export default {
  namespaced: true,
  state: {
    routes: constantRoutes,
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      // console.log('constantRoutes', constantRouteMap)
      state.routes = getSideMenus(constantRoutes.concat(routes))
    },
  },
  actions: {
    generateRoutes ({ commit }) {
      return getMenus().then(res => {
        // const accessedRoutes = accessAsyncRoutes(res.data)
        commit('SET_ROUTES', JSON.parse(JSON.stringify(res.data)))
        return accessAsyncRoutes(res.data)
      })
    },
  },
}
